import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Select from 'v3/components/Select';
import { fetchOwners } from 'utils/fetches';

import Card, { DefaultLoadingBodyComponent } from 'v3/components/Card';
import { Text } from 'v3/components';


export default function OwnerData({ setData, data, errors }) {

  return (
    <Card
      LoadingBodyComponent={() => (
        <DefaultLoadingBodyComponent linesCount={1} perLine={1} />
      )}
      header={
        <Text color="#464E5F" type="header">
          Proprietário
        </Text>
      }
    >
      <Row className="form">
        <Col xl={6} lg={6} md={12} xs={12} >
          <Select.Async
            label={'Proprietário do documento *'}
            onSearch={fetchOwners}
            onChange={value => setData({ ...data, owner: value })}
            value={data?.owner}
            getOptionLabel={option => option.label}
            getOptionValue={option => option.id}
            error={errors?.owner}
          />
        </Col>
        <Col xl={6} lg={6} md={12} xs={12} >
          <Select.Async
            label={'Beneficiário do veículo *'}
            onSearch={fetchOwners}
            onChange={value => setData({ ...data, beneficiary: value })}
            value={data?.beneficiary}
            getOptionLabel={option => option.label}
            getOptionValue={option => option.id}
            error={errors?.beneficiary}
          />
        </Col>
      </Row>
    </Card>
  );
}
